<template>
  <div ref="pageTop">
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />
      <v-toolbar-title>
        <h1 class="headline font-weight-bold">Associated Press ({{ articles.length }})</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="!articleDetails.altids"
        color="primary"
        @click="publishArticle"
      >Create Article</v-btn>
    </v-app-bar>
    <div
      class="ma-4"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <v-row>
        <v-col md="4" class="article-col">
          <v-row
            v-for="(item, i) in articles"
            :key="i"
            :class="{'selected-item' : i === activeIndex}"
            class="rounded-0 item-row"
            @click="selectArticle(item, i); $vuetify.goTo(target, gotoOptions)"
          >
            <v-col md="4" class="article-image">
              <v-img
                v-if="item.feedImages"
                width="120"
                height="100%"
                :src="item.feedImages.thumbnail.href"
                contain
              ></v-img>
              <v-img
                v-else
                width="120"
                height="100%"
                :src="require('@/assets/images/no-image.png')"
                contain
              ></v-img>
            </v-col>
            <v-col md="8">
              <v-list-item three-line dense>
                <v-list-item-content>
                  <v-list-item-title class="text-h7 text-wrap font-weight-bold">{{ item.headline }}</v-list-item-title>
                  <!-- <v-list-item-subtitle class="article-description">{{ item.description_caption }}</v-list-item-subtitle> -->
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-skeleton-loader v-if="loading" type="list-item" />
        </v-col>
        <v-col md="8">
          <v-row class="article-title">
            <v-img
              :src="require('@/assets/images/ap.svg')"
              width="auto"
              height="50px"
              contain
              class="ap-logo"
            ></v-img>

            <v-col md="10">
              <h4 v-if="articleDetails">{{ articleDetails.headline }}</h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <v-img v-if="previewImage" :src="previewImage" contain class="selected-article-image"></v-img>
              <v-img
                v-else
                :src="require('@/assets/images/no-image.png')"
                contain
                class="selected-article-image"
              ></v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <p class="text-justify" v-if="articleDetails">{{ articleDetails.headline }}</p>
              <div
                v-if="articleDetails.content_description"
                v-html="articleDetails.content_description"
              ></div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="gettingArticleDetails" :z-index="3">
      <v-dialog v-model="gettingArticleDetails" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Fetching Article Data
            <v-progress-linear indeterminate color="white"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <create-article
      :APArticle="articleDetails"
      :publishAPArticle="publishAPArticle"
      :apMedia="true"
      @resetPublishAPArticle="resetPublishAPArticle"
    ></create-article>
  </div>
</template>

<script>
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import { mapState, mapActions } from 'vuex'
import CreateArticle from '@/components/modals/article/CreateArticle'
import infiniteScroll from 'vue-infinite-scroll'

export default {
  name: 'AssociatedPress',
  components: {
    AppBarNavIcon,
    CreateArticle
  },
  data () {
    return {
      loading: false,
      gettingArticleDetails: false,
      publishAPArticle: false,
      activeIndex: null,
      gotoOptions: {
        duration: 300,
        offset: 0,
        easing: 'easeInOutCubic'
      },
      previewImage: ''
    }
  },

  directives: {
    infiniteScroll
  },

  methods: {
    ...mapActions({
      getAPArticles: 'associatedPress/getAPArticles',
      getAPArticleDetails: 'associatedPress/getAPArticleDetails',
      loadMoreAPArticles: 'associatedPress/loadMoreAPArticles'
    }),

    async fetchArticles (page = 1) {
      let params = { page }
      this.loading = true

      params.page_size = '20'
      params.query_syntax = 'type:text'
      params.sort = 'versioncreated:desc'
      params.pricing = true
      await this.getAPArticles(params)
      this.loading = false
    },
    async selectArticle (article, i) {
      this.activeIndex = i
      this.gettingArticleDetails = true
      this.previewImage = article.feedImages ? article.feedImages.preview.href : ''
      let params = { itemId: article.altids.itemid }
      await this.getAPArticleDetails(params)
      this.gettingArticleDetails = false
    },
    publishArticle () {
      // this.publishAPArticle = true
      this.$router.push({ name: 'associated-press.create-article',
        params: {
          id: this.articleDetails.altids.itemid
        }
      })
    },
    resetPublishAPArticle () {
      this.publishAPArticle = false
    },
    async loadMore () {
      this.loading = true
      let params = { url: this.listMeta.next_page_url }

      if (this.listMeta.current_page < this.listMeta.last_page) {
        await this.loadMoreAPArticles(params)
      }
      this.loading = false
    }
  },
  computed: {
    ...mapState({
      articles: state => state.associatedPress.list,
      articleDetails: state => state.associatedPress.articleDetails,
      articleCreateAlert: state => state.article.articleCreateAlert,
      articleCreateStatus: state => state.article.articleCreateStatus,
      listMeta: state => state.associatedPress.listMeta
    }),
    target () {
      const value = this.$refs['pageTop']
      return value
    }
  },
  created () {
    this.fetchArticles()
  }
}
</script>

<style scoped>
.item-row {
  border-style: thin solid rgba(0, 0, 0, 0.12);
  border-width: thin;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.12);
}
.article-image {
  padding-left: 1px;
  padding-right: 0;
}
.article-description {
  -webkit-line-clamp: 4;
}
.item-row:hover {
  cursor: pointer;
  background-color: #eaf5ff;
}
.article-title {
  background-color: #ececec;
}
.ap-logo {
  padding: 0 !important;
}
.selected-article-image {
  width: auto;
  height: 500px;
}
.selected-item {
  background-color: #eaf5ff;
}
</style>
